//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const RefereeMediator = require('@/tbs/controller/RefereeMediator')
const Referee = require('@/tbs/model/vo/Referee')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchRefereeMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchRefereeMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchRefereeMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        if (!this._bridge.isCreate()) {
            this.creationComplete()
        }
        if (this._bridge.isList()) {
            this.target().organizationId = this._bridge.getRouteQuery('organizationId')
            this.target().matchId = this._bridge.getRouteParam('id')
        }
        else {
            this.target().referee.organizationId = this._bridge.getRouteQuery('organizationId')
            this.target().referee.matchId = this._bridge.getRouteParam('id')
        }
    },
    handleCustomizedEvent: function(event) {
        const self = this
        if (event.type == 'load-referee') {
            self.loadViewObjectData(self.convertor(), {organizationId: self._bridge.getRouteQuery('organizationId'), matchId: self._bridge.getRouteParam('id')}, function(data) {
                console.log('load candicated referee data', data)
                data = data.sort(function(a, b) {
                    // console.log('sort', a.label, b.label)
                    return a.label.localeCompare(b.label)
                })
                self.target().candicatedRefereeList = data
            }, 'load')
        }
        else if (event.type == 'add-referee') {
            self.commitViewObjectData(self.convertor(), event.data, function(data) {
                console.log('add candicated referee data', data)
                self.handleCreationComplete()
            }, 'add')
        }
        else if (event.type == 'invite-referee') {
            new RefereeMediator(this._bridge).sendRefereeInvite(event.data, new Referee)
        }
        else {
            return true
        }
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgListMatchReferee') {
            this._bridge.goToScene('OrgManageMatch', {id: this._bridge.getRouteParam('id')})
        }
        else {
            this._bridge.back()
        }
    },
    handleRemoveService: function() {
        this.handleCreationComplete()
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchRefereeMediator, BaseMediator);

module.exports = tbs_controller_MatchRefereeMediator